import Vue from 'vue'
import VueRouter from 'vue-router'
import { basicRoutes } from './routes'

Vue.use(VueRouter)

const createRouter = () =>
  new VueRouter({
    routes: basicRoutes,
    scrollBehavior: () => ({
      y: 0,
    }),
  })

const router = createRouter()

// 重置路由 reset router
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

// push
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

// replace
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err)
}

export default router
